import React from "react";
import PegPie from "./PegPie";
import { formatLongDate } from "../../util/helper/formatDate";
import { PegsRedeemed } from "./PegsRedeemed";

var RewardCard = function RewardCard(_ref) {
  var item = _ref.item;
  var points = item.rewardsPointsRedeemed || item.rewardsPointsEarned;
  var detailsString = "";

  if (item.mappedOrderNumber && item.mappedEventType === 'orderItem') {
    detailsString = "Order #".concat(item.mappedOrderNumber, " | ").concat(item.handOffType, " ");
  } else if (item.mappedEventType === 'rewardItem') {
    detailsString = item.apiDetail;
  } else if (item.mappedEventType === 'return') {
    detailsString = "Order #".concat(item.mappedOrderNumber, " | ").concat(item.apiDetail, " ");
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "cb-reward-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leftCol"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card__header"
  }, /*#__PURE__*/React.createElement("h3", null, formatLongDate(item.transactionDate))), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-order"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__title"
  }, detailsString)), item.pegsRedeemedOnOrder && /*#__PURE__*/React.createElement(PegsRedeemed, {
    pegs: item.pegsRedeemedOnOrder
  })), /*#__PURE__*/React.createElement("div", {
    className: "cb-reward-card__rightCol"
  }, points ? /*#__PURE__*/React.createElement(PegPie, {
    number: points
  }) : ""));
};

export default RewardCard;